<template>
  <div class="training-instruction-sub-heading">
    <el-button class="training-instruction-sub-heading__back"
               icon="el-icon-arrow-left"
               circle
               @click="onBack" />
    <h2 class="training-instruction-sub-heading__title">
      <span class="training-instruction-sub-heading__title-text">{{ title }}</span>
      <span v-if="hasEntityId"
            class="training-instruction-sub-heading__id-badge">ID：{{ entityId }}</span>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'TrainingInstructionSubHeading',
  props: {
    title: {
      type: String,
      required: true,
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    fallbackPath: {
      type: String,
      default: '/training/instruction',
    },
  },
  computed: {
    hasEntityId () {
      return this.entityId !== null && this.entityId !== undefined && this.entityId !== ''
    },
  },
  methods: {
    onBack () {
      if (window.history.length > 1) {
        this.$router.back()
        return
      }
      this.$router.push(this.fallbackPath)
    },
  },
}
</script>

<style lang="scss" scoped>
.training-instruction-sub-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  &__back {
    flex-shrink: 0;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
  }

  &__title-text {
    min-width: 0;
  }

  &__id-badge {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: #606266;
    background: #f4f4f5;
    border: 1px solid #e9e9eb;
    font-variant-numeric: tabular-nums;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/components/TrainingInstructionSubHeading.vue